require.config
  paths:
    jquery:   'jquery.min'
    jsrender: 'jsrender.min'
    moment:   'moment.min'
  shim:
    jsrender: ['jquery']

define ['jquery', 'jsrender', 'moment'], ($, $jsr, moment)->

  ### ===== XJ-Storage クラス ===== ###
  class XJStorage

    ### コンストラクタ ###
    constructor: () ->
      xj = @
      ### バージョン ###
      @version = '1.0.2'
      ### APIのドメイン ###
      @domain = 'www.xj-storage.jp'
      ### 企業コード ###
      @company = '79210'
      ### 期の起算年月日（YYYY/MM/DD） ###
      @firstDate = '1966/05/31'
      ### 期の初期値 ###
      @firstPeriod = 28
      ### 資料コードのグループ定義 ###
      @groupCode = {}
      ### ニュースリリースのラベル定義 ###
      @groupLabel = {}

      ### jsRender のコンバータ設定 ###
      $.views.converters

        ###
          文字列を指定文字列で指定桁数で埋める
          {fill:val length='(:number)' str='(:string)'}
        ###
        fill: (val) ->
          return xj.fill(val, this.tagCtx.props.length, this.tagCtx.props.str)

        ###
          日付情報を書式に変換
          {date:val format='(:string)'}
        ###
        date: (val) ->
          date = moment(new Date(val))
          format = if this.tagCtx.props.format? then this.tagCtx.props.format else 'YYYY年M月D日'
          return date.format(format)

        ###
          ファイルサイズを自動的に単位を付けて変換
          {fsize:size}
        ###
        fsize: (size) ->
          return xj.fsize(size)

        ###
          資料コードから定義ラベルを取得
          {label:disclosureCode}
        ###
        label: (disclosureCode) ->
          for label of xj.groupLabel
            if $.inArray(parseInt(disclosureCode), xj.groupLabel[label].doctype) isnt -1
              if this.tagCtx.props.get is 'id'
                return xj.groupLabel[label].id
              else
                return label
        ###
          ファイル情報からリンク用のHTMLタグを生成
          {link:files fileType='(XJ-Storage:FileType)' text='(:string)' className='(:string)' unitPrefix='(:string)' unitSuffix='(:string)'}
        ###
        link: (files) ->
          unless this.tagCtx.props.text?
            throw new Error('Invaild "link:text"')
            return false
          unless files?
            return this.tagCtx.props.text
          showPage = if this.tagCtx.props.showPage? then this.tagCtx.props.showPage else true
          for file in files
            if file.type is this.tagCtx.props.fileType
              url          = encodeURI(file.url)
              blank        = if file.url.match(/\.(pdf)$/) or not file.url.match(new RegExp('^https?://'+location.hostname+'/')) then ' target="_blank"' else ''
              tmpLinkClass = []
              if this.tagCtx.props.className?
                tmpLinkClass.push this.tagCtx.props.className
              if file.url.match(/\.(pdf)$/)
                tmpLinkClass.push 'pdf'
              else if not file.url.match(new RegExp('^https?://'+location.hostname+'/'))
                tmpLinkClass.push 'blank'
              linkClass  = if tmpLinkClass.length isnt 0 then ' class="'+tmpLinkClass.join(' ')+'"' else ''
              textClass  = if this.tagCtx.props.className? then "#{this.tagCtx.props.className}_text" else 'text'
              unitClass  = if this.tagCtx.props.className? then "#{this.tagCtx.props.className}_unit" else 'unit'
              text       = this.tagCtx.props.text
              size       = xj.fsize(file.size)
              page       = if showPage and file.page? and parseInt(file.page) isnt 0 then "/#{file.page}P" else ''
              unitPrefix = if this.tagCtx.props.unitPrefix? then this.tagCtx.props.unitPrefix else '（'
              unitSuffix = if this.tagCtx.props.unitSuffix? then this.tagCtx.props.unitSuffix else '）'
              unit       = if file.size? and parseInt(file.size) isnt 0 then "<span class='#{unitClass}'>#{unitPrefix}#{size}#{page}#{unitSuffix}</span>" else ''
              return "<a href='#{url}'#{linkClass}#{blank}><span class='#{textClass}'>#{text}</span>#{unit}</a>"
          throw new Error('Invaild "link:fileType"')
          return false

      ### jsRender のヘルパ設定 ###
      $.views.helpers
        ###
          指定日時を現在と比較して指定日数を過ぎているか比較し真偽値を返す
          {{~isNew(date, expire)}
        ###
        isNew: (date, expire = 30) ->
          date  = moment(new Date(date))
          later = moment().diff(date,'days')
          return if later < expire then true else false

        ###
          ファイル情報から指定のパラメータを取得
          {{~finfo(files, fileType, get)}}
        ###
        finfo: (files, fileType, get) ->
          for file in files
            if file.type is fileType
              switch get
                when 'url'
                  return encodeURI(file.url)
                when 'size'
                  return xj.fsize(file.size)
                when 'page'
                  return file.page
                when 'mark'
                  if file.url.match(/\.(pdf)$/)
                    return 'pdf'
                  else if not file.url.match(new RegExp('^https?://'+location.hostname+'/'))
                    return 'blank'
                  return false
                else
                  throw new Error('Invaild "finfo:get"')
                  return false
          throw new Error('Invaild "finfo:fileType"')
          return false

    ### メソッド： ファイルサイズを自動的に単位を付けて変換 ###
    fsize: (size) ->
      unit = ['Byte', 'KB', 'MB', 'GB']
      idx  = 0
      for i in [1..unit.length]
        if size < 1024 then break
        size = size / 1024
        idx = i
      size = if idx >= 2 then Math.round(size*10)/10 else Math.round(size)
      return if size is 0 then '' else size+unit[idx]

    ### メソッド： XJ-Storage の正常返却フォーマットに統一 ###
    checkData: (data) ->
      getData =
        items: []
        length: 0
      if data? and data.items instanceof Array
        getData = data
      return getData

    ### メソッド： XJ-Storage API に問い合わせて jqXHR を返す ###
    getList: (options) ->
      xj = @
      arrayUnique = (array) ->
        storage = {}
        uniqueArray = []
        for i in [0..array.length-1]
          value = array[i]
          if (not storage[value]?)
            storage[value] = true
            uniqueArray.push(value)
        return uniqueArray

      if options.doctype?  and options.doctype  instanceof Array
        options.doctype = arrayUnique(options.doctype).join(',')
      if options.category? and options.category instanceof Array
        options.category = arrayUnique(options.category).join(',')

      options = $.extend(true, {
        doctype: null
        fileType: null
        category: null
        fdate: null
        pdate: null
        len: 10000
        browser: null
        browserType: null
      }, options,  {
        company: xj.company
        output: 'json'
      } )
      $res = $.ajax(
        url: '//'+xj.domain+'/public-list/GetList.aspx'
        type: 'GET'
        cache: false
        dataType: 'jsonp'
        data: options
      )
      return $res

    ### メソッド： XJ-Storage API に問い合わせて返却された JSON を jsRender に渡して処理を行う ###
    render: (target, template, options) ->
      xj = @
      $res = xj.getList(options)
      $res
        .done (data, statusText, jqXHR) ->
          data = xj.checkData(data)
          $('#'+target).html $('#'+template).render(data)
          return
        .fail (jqXHR, statusText, errorThrown) ->
          throw new Error('通信に失敗しました -'+statusText+'-'+errorThrown)
          return
      return

    ### メソッド： XJ-Storage API 問い合わせ結果を指定期間で分割する ###
    splitDataInterval: (data, target='year', month=1, day=1) ->
      splitData = {}
      data = @checkData(data)
      for item in data.items
        pubdate = moment(new Date(item.publishDate)).add(month - 1,'months').add(day - 1,'days')
        switch target
          when 'period'
            splitKey = @convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).period
          when 'jp'
            splitKey = @convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).jp
          when 'ad'
            splitKey = @convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).ad
          else
            splitKey = pubdate.year()
        unless splitData[splitKey]?
          splitData[splitKey] =
            items: []
            length: 0

        splitData[splitKey].items.push item
        splitData[splitKey].length++

      for key, val in splitData
        splitData[key] = @checkData(val)

      return splitData

    ### メソッド： XJ-Storage API 問い合わせ結果を先頭から指定件数のみ取得する ###
    shiftData: (data, length = 20) ->
      data = @checkData(data)
      shiftData = data.items.slice(0, length)
      return {
        items: shiftData
        length: shiftData.length
      }

    ### メソッド： XJ-Storage API 問い合わせ結果を指定資料コードのみ取得する ###
    filterData: (data, doctype) ->
      data = @checkData(data)
      filterData = []
      for item in data.items
        if $.inArray(parseInt(item.disclosureCode), doctype) isnt -1
          filterData.push item
      return {
        items: filterData
        length: filterData.length
      }

    ### メソッド： 期数表記の相互変換 ###
    convertDateFormat: (val, date) ->
      era =
        '平成': 1988
        '昭和': 1925
        '大正': 1911
        '明治': 1867

      firstDate   = moment(new Date(@firstDate))
      firstPeriod = @firstPeriod
      unless firstDate.isValid()
        throw new Error('Invaild "XJStorage.firstDate"')

      checkDate = moment(new Date(val))
      if val.match /^\d{4}\/\d{2}\/\d{2}$/ and checkDate.isValid()
        if firstDate > checkDate
          throw new Error('Invaild "convertDateFormat more than XJStorage.firstDate "')
      else
        ### 全角英数を半角に変換  ###
        val = val.replace /[Ａ-Ｚａ-ｚ０-９]/g, (s) ->
          return String.fromCharCode(s.charCodeAt(0)-0xFEE0)
        if val.match /(\d+)期/
          ### 期数表記を日付情報に変換  ###
          if parseInt(RegExp.$1) < firstPeriod
            throw new Error('Invaild "convertDateFormat less than XJStorage.firstPeriod"')
          else
            checkDate = firstDate.clone().add(parseInt(RegExp.$1) - 1 - firstPeriod, 'years')
        else if val.match /(明治|大正|昭和|平成)(\d+)年\d+月期/
          ### 和暦表記を日付情報に変換  ###
          checkDate = firstDate.clone().year(parseInt(era[RegExp.$1]) + parseInt(RegExp.$2))
        else if val.match /(\d{4})年\d+月期/
          ### 西暦表記を日付情報に変換  ###
          checkDate = firstDate.clone().year(parseInt(RegExp.$1))
        else if date?
          ### 書式にマッチしなかったときは第二引数の日付を利用する ###
          checkDate = moment(new Date(date))
          unless checkDate.isValid()
            throw new Error('Invaild "convertDateFormat"')
          else if firstDate > checkDate
            throw new Error('Invaild "convertDateFormat more than XJStorage.firstDate "')

        for key,y of era
          if checkDate.year() > y
            jpera = key
            break

      year = checkDate.year()

      return {
        date: checkDate
        period: '第'+Math.ceil(checkDate.diff(new Date(firstDate.year()+'/01/01'), 'years', true)+firstPeriod)+'期'
        ad: year+'年'+(firstDate.month()+1)+'月期'
        jp: jpera+parseInt(year-era[jpera])+'年'+(firstDate.month()+1)+'月期'
      }
